import React, { Component } from 'react';
import "../css/Products.css";
import products from "../json/products.json";
import { Link } from "react-router-dom";
import { Lines } from "react-preloaders";
import productImages from "../images";

export default class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
    };
  }

  componentDidMount() {
    this.setState({
      products: products,
    });
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <div className="products container">
          <h1 className="text-center">Products</h1>
          <hr className="text-center" />
          <div className="row">
            <div className="col-lg-12 col-12 mx-auto">
              <ul className="nav nav-tabs">
                <li className="nav-item mx-auto">
                  <a className="nav-link active show" data-toggle="tab" href="#tab-1">
                    All
                  </a>
                </li>
                <li className="nav-item mx-auto">
                  <a className="nav-link" data-toggle="tab" href="#tab-2">
                    Chair
                  </a>
                </li>
                <li className="nav-item mx-auto">
                  <a className="nav-link" data-toggle="tab" href="#tab-3">
                    Lamp
                  </a>
                </li>
                <li className="nav-item mx-auto">
                  <a className="nav-link" data-toggle="tab" href="#tab-4">
                    Table
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg-12 col-10 m-auto">
              <div className="tab-content">
                <div className="tab-pane active show" id="tab-1">
                  <div className="row">
                    {this.state.products.map((product, index) => (
                      <div className="col-lg-3 col-md-4 col-6" key={product.id}>
                        <img src={productImages[product.id]} className="img-fluid image rounded shadow" alt="" />
                        <Link to={"/product?id=" + product.id}>
                          <h5>{product.title}</h5>
                        </Link>
                        <p className="text-justify">{product.price}</p>
                        <div className="middle">
                          <div className="text">
                            <Link to={"/product?id=" + product.id}>
                              <i className="fa fa-external-link" aria-hidden="true" title="More Details"></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="tab-pane" id="tab-2">
                  <div className="row">
                    {this.state.products
                      .filter((product) => product.category === "Chair")
                      .map((product, index) => (
                        <div className="col-lg-3 col-md-4 col-6" key={product.id}>
                          <img src={productImages[product.id]} className="img-fluid image rounded shadow" alt="" />
                          <Link to={"/product?id=" + product.id}>
                            <h5>{product.title}</h5>
                          </Link>
                          <p className="text-justify">{product.price}</p>
                          <div className="middle">
                            <div className="text">
                              <Link to={"/product?id=" + product.id}>
                                <i className="fa fa-external-link" aria-hidden="true" title="More Details"></i>
                              </Link>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
                <div className="tab-pane" id="tab-3">
                  <div className="row">
                    {this.state.products
                      .filter((product) => product.category === "Lamp")
                      .map((product, index) => (
                        <div className="col-lg-3 col-md-4 col-6" key={product.id}>
                          <img src={productImages[product.id]} className="img-fluid image rounded shadow" alt="" />
                          <Link to={"/product?id=" + product.id}>
                            <h5>{product.title}</h5>
                          </Link>
                          <p className="text-justify">{product.price}</p>
                          <div className="middle">
                            <div className="text">
                              <Link to={"/product?id=" + product.id}>
                                <i className="fa fa-external-link" aria-hidden="true" title="More Details"></i>
                              </Link>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
                <div className="tab-pane" id="tab-4">
                  <div className="row">
                    {this.state.products
                      .filter((product) => product.category === "Table")
                      .map((product, index) => (
                        <div className="col-lg-3 col-md-4 col-6" key={product.id}>
                          <img src={productImages[product.id]} className="img-fluid image rounded shadow" alt="" />
                          <Link to={"/product?id=" + product.id}>
                            <h5>{product.title}</h5>
                          </Link>
                          <p className="text-justify">{product.price}</p>
                          <div className="middle">
                            <div className="text">
                              <Link to={"/product?id=" + product.id}>
                                <i className="fa fa-external-link" aria-hidden="true" title="More Details"></i>
                              </Link>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Lines customLoading={this.state.products.length === 0} />
      </>
    );
  }
}
